import React, { FC } from 'react';
import type { Animation as AnimationFields } from '@/generated/graphql';

interface AnimationControlEditProps {
    uniqueId: string | number;
    fields: AnimationFields;
    frameCount: number;
}

const AnimationControlEdit: FC<AnimationControlEditProps> = ({
    uniqueId,
    fields,
    frameCount,
}) => {
    return (
        <div id={`EditInfo_${uniqueId}`} className="Animation_editInfo">
            <span
                id={`EditInfoText_${uniqueId}`}
                className="Animation_editInfoText"
            >
                {fields.subDir} | {frameCount}
            </span>
            <div
                id={`EditInfoTooltip_${uniqueId}`}
                className="Animation_hudTooltip"
            >
                Klicken zum Kopieren
            </div>
        </div>
    );
};

export default AnimationControlEdit;
